import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import { withRouter } from 'react-router-dom';
import InvestorOnboardingContentSC, { ContentWrapSC } from './investor-onboarding-content.styled';
import { BodyText, HeadingThree, SmallText } from '../typography';
import OnboardingCard from './onboarding-card';
import PersonalForm from './personal-form';
import onBoardingFormData from './investor-onboarding-proces-data';
import Button from '../ui/button';
import moment from 'moment';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import { ReactComponent as IdentityCard } from '../../assets/img/svg/identity-card.svg';
import { ReactComponent as OtherDocument } from '../../assets/img/svg/other-document.svg';

import WishmakerModal from '../ui/modal/modal';
import OnboardingSmsModal from './onboarding-sms-modal';
import InlineLoading from '../ui/inline-loading';
import IdentityForm from './identity-form/identity-form';
import SummaryInfo from './summary-info';
import AmlForm from './aml-form';
import DepositForm from './deposit-form';

const _InvestorOnboardingContent = ({
  getInvestorOnboardingStep,
  onBoardingStep,
  sendInvestorOnboardingIdentityCards,
  getInvestorDocumentTypes,
  onBoardingDocumentTypes,
  onBoardingDocuments,
  personalNumber,
  onBoardingStepData,
  sendSms,
  sendInvestorOnboardingStep,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isServerError, setIsServerError] = useState(false);
  const [isGetStepInterval, setIsGetStepInterval] = useState(false);
  const [onBoardingData, setOnboardingData] = useState(onBoardingFormData);
  /* Modal Data */
  const [isSMSModalOpened, setSMSModalOpened] = useState(false);
  const [additionalModalData, setAdditionalModalData] = useState({});
  const [additionalModalInfo, setAdditionalModalInfo] = useState('');

  const [isRefused, setIsRefused] = useState(false);
  const [isWaitingForAMLConfirmation, setIsWaitingForAMLConfirmation] = useState(false);

  /* Steps */
  const personalData = onBoardingData[0];
  const identityData = onBoardingData[2];
  const summaryInfo = onBoardingData[3];
  const confirmRegistration = onBoardingData[6];
  const amlData = onBoardingData[7];
  const finalConfirm = onBoardingData[8];

  useEffect(() => {
    if (onBoardingStepData.is_refused) {
      setIsRefused(true);
    }
  }, [onBoardingStepData]);

  useEffect(() => {
    if (onBoardingStepData.is_waiting_for_confirmation) {
      setIsWaitingForAMLConfirmation(true);
    }
  }, [onBoardingStepData]);

  useEffect(() => {
    getInvestorOnboardingStep();
  }, [getInvestorOnboardingStep]);

  useEffect(() => {
    getInvestorDocumentTypes();
  }, [getInvestorDocumentTypes]);

  /* Check if Data Else Handle Error */
  useEffect(() => {
    const sortOnboardingSteps = () => {
      let newData = onBoardingData.map((item) =>
        item.id < onBoardingStep
          ? { ...item, active: true, status: 'done', opened: false, loading: false }
          : item.id === onBoardingStep
          ? { ...item, active: true, status: 'pending', opened: true }
          : item.id > onBoardingStep
          ? { ...item, active: false, status: 'pending', opened: false, loading: false }
          : item
      );
      setOnboardingData(newData);
      setIsGetStepInterval(false);
    };

    if (onBoardingStep !== null && onBoardingStep !== 0) {
      sortOnboardingSteps();
      setIsLoading(false);
      setIsGetStepInterval(false);
    }

    if (onBoardingStep === null) {
      setIsLoading(true);
      setIsGetStepInterval(true);
      setTimeout(() => {
        setIsLoading(false);
        setIsGetStepInterval(false);
        setIsServerError(true);
      }, 20 * 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onBoardingStep]);

  useEffect(() => {
    if (finalConfirm.active === true && finalConfirm.status === 'pending') {
      onConfirmationStep(finalConfirm.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalConfirm.id, finalConfirm.status]);

  /* Get Step Status Every 3 sec. */
  useEffect(() => {
    let interval = '';
    if (!confirmRegistration.active && isGetStepInterval && !isRefused) {
      interval = setInterval(() => {
        getInvestorOnboardingStep();
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [confirmRegistration, isGetStepInterval, getInvestorOnboardingStep, isRefused]);

  /* Refresh if Server Error */
  const refreshProcess = () => {
    window.location.reload(false);
  };

  /* Step is Loading */
  const changeLoadingStatus = (itemId, loadingStatus) => {
    const newLoadingData = onBoardingData.map((item) =>
      item.id === itemId ? { ...item, loading: loadingStatus } : item
    );
    setOnboardingData(newLoadingData);
  };

  /* STEP 1 PERSONAL FORM */
  const onPersonalDataConfirm = (formData) => {
    let formattedData = {};
    formattedData = {
      accepted: true,
      wm_number: personalNumber,
      address: formData.street,
      first_name: formData.first_name,
      last_name: formData.last_name,
      personal_identification_number: formData.birth_number.replace('/', ''),
      birth_date: moment(formData.birth_date).format('DD.MM.YYYY'),
      phone: formData.phone.replace(/ /g, ''),
      email: formData.email,
      city: formData.city,
      country: formData.country,
      indicative_number: formData.house_number,
      //district: formData.region,
      postal_code: formData.zip,
      is_not_entrepreneur: formData.entrepreneur,
    };

    setAdditionalModalData(formattedData);
    setAdditionalModalInfo('onboarding_sms_modal_step_one_caution');
    sendSms({ phone: formData.phone.replace(/ /g, '') });
    setSMSModalOpened(true);
  };

  /* STEP 3 IDENTITY DOCUMENTS */
  const onIdentityDataConfirm = (formData) => {
    const formattedData = new FormData();
    let persistingDocuments = [];

    if (
      formData.first_identity_image_front === null &&
      onBoardingStepData.identity_documents[0].documents[0].id !== null
    ) {
      persistingDocuments = [
        ...persistingDocuments,
        onBoardingStepData.identity_documents[0].documents[0].id,
      ];
    }
    if (
      formData.first_identity_image_back === null &&
      onBoardingStepData.identity_documents[0].documents[1].id !== null
    ) {
      persistingDocuments = [
        ...persistingDocuments,
        onBoardingStepData.identity_documents[0].documents[1].id,
      ];
    }
    if (
      formData.second_identity_image_front === null &&
      onBoardingStepData.identity_documents[1].documents[0].id !== null
    ) {
      persistingDocuments = [
        ...persistingDocuments,
        onBoardingStepData.identity_documents[1].documents[0].id,
      ];
    }
    if (
      formData.second_identity_image_back === null &&
      onBoardingStepData.identity_documents[1].documents[1].id !== null
    ) {
      persistingDocuments = [
        ...persistingDocuments,
        onBoardingStepData.identity_documents[1].documents[1].id,
      ];
    }

    persistingDocuments.map((value) => formattedData.append('not_delete_ids[]', value));
    formattedData.append('type_doc_1', formData.first_identity);
    formattedData.append('document_number_1', formData.first_identity_number);
    formattedData.append('type_doc_2', formData.second_identity);
    formattedData.append('document_number_2', formData.second_identity_number);

    if (formData.first_identity_image_front !== null) {
      formattedData.append('identity_doc_1_front', formData.first_identity_image_front);
    }
    if (formData.first_identity_image_back !== null) {
      formattedData.append('identity_doc_1_back', formData.first_identity_image_back);
    }

    if (formData.second_identity_image_front !== null) {
      formattedData.append('identity_doc_2_front', formData.second_identity_image_front);
    }
    if (formData.second_identity_image_back !== null) {
      formattedData.append('identity_doc_2_back', formData.second_identity_image_back);
    }

    const onSuccess = () => {
      getInvestorOnboardingStep();
    };

    const onError = () => {
      changeLoadingStatus(identityData.id, false);
    };

    const sendInvestorStep = async () => {
      await sendInvestorOnboardingIdentityCards({
        data: formattedData,
        onSuccess,
        onError,
      });
      changeLoadingStatus(identityData.id, true);
    };
    sendInvestorStep();
  };

  /* STEP 4 SUMMARY INFO */
  const onSummaryInfoClick = (status) => {
    let formattedData = '';

    if (status === 'declined') {
      formattedData = {
        accepted: false,
      };

      const onSuccess = () => {
        getInvestorOnboardingStep();
        changeLoadingStatus(summaryInfo.id, false);
      };

      sendInvestorOnboardingStep({
        data: formattedData,
        onSuccess,
        onBadSmsCode: () => {},
        onError: () => {},
      });
      changeLoadingStatus(summaryInfo.id, true);
    } else {
      formattedData = {
        accepted: true,
      };
      setAdditionalModalInfo('onboarding_sms_modal_step_three_caution');
      setAdditionalModalData(formattedData);
      sendSms();
      setSMSModalOpened(true);
    }
  };

  /* STEP 8 AML FORM */
  const onAmlDataConfirm = (formData) => {
    let formattedData = { ...formData, accepted: true };

    setAdditionalModalInfo('onboarding_sms_modal_step_thirteen_caution');
    setAdditionalModalData(formattedData);
    sendSms();
    setSMSModalOpened(true);
  };

  /* Confirmation Steps */
  const onConfirmationStep = (stepId) => {
    setIsGetStepInterval(true);
    changeLoadingStatus(stepId, true);
  };

  const onEntryUserAreaClick = () => {
    const formattedData = {
      accepted: true,
    };

    const onSuccess = () => {
      refreshProcess();
    };

    sendInvestorOnboardingStep({
      data: formattedData,
      onSuccess,
      onBadSmsCode: () => {},
      onError: () => {},
    });
  };

  if (isLoading)
    return (
      <InvestorOnboardingContentSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </InvestorOnboardingContentSC>
    );

  if (isServerError)
    return (
      <InvestorOnboardingContentSC>
        <div className="err-wrap">
          <HeadingThree>Hups</HeadingThree>
          <BodyText className="mid-info-text bolder">
            <FormattedHTMLMessage
              id="error_message_server"
              defaultMessage={dlt['error_message_server']}
            />
          </BodyText>
          <Button type="PRIMARY" onClick={() => refreshProcess()}>
            <FormattedMessage
              id="global_redo_process"
              defaultMessage={dlt['global_redo_process']}
            />
          </Button>
        </div>
      </InvestorOnboardingContentSC>
    );

  return (
    <InvestorOnboardingContentSC>
      <WishmakerModal isOpened={isSMSModalOpened} onClose={() => setSMSModalOpened(false)}>
        <OnboardingSmsModal
          additionalData={additionalModalData}
          additionalInfo={additionalModalInfo}
          onClose={() => setSMSModalOpened(false)}
        />
      </WishmakerModal>
      <ContentWrapSC>
        {onBoardingStep <= 3 ? (
          <div className="required-documents-wrapper">
            <BodyText className="bolder">
              <FormattedHTMLMessage
                id="onboarding_investor_required_documents_banner_title"
                defaultMessage={dlt['onboarding_investor_required_documents_banner_title']}
              />
            </BodyText>
            <BodyText className="subtext black-transparent-lighter bolder">
              <FormattedHTMLMessage
                id="onboarding_investor_required_documents_banner_subtext"
                defaultMessage={dlt['onboarding_investor_required_documents_banner_subtext']}
              />
            </BodyText>
            <div className="two-columns">
              <div className="column">
                <IdentityCard />
                <p>
                  <FormattedHTMLMessage
                    id="onboarding_investor_required_documents_identity_card"
                    defaultMessage={dlt['onboarding_investor_required_documents_identity_card']}
                  />
                </p>
              </div>
              <div className="column">
                <OtherDocument />
                <div>
                  <p>
                    <FormattedHTMLMessage
                      id="onboarding_investor_required_documents_other_document"
                      defaultMessage={dlt['onboarding_investor_required_documents_other_document']}
                    />
                  </p>
                  <p>
                    <SmallText>
                      <FormattedHTMLMessage
                        id="onboarding_investor_required_documents_other_document_subtext"
                        defaultMessage={
                          dlt['onboarding_investor_required_documents_other_document_subtext']
                        }
                      />
                    </SmallText>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {personalData.active ? (
          <OnboardingCard
            status={personalData.status}
            opened={personalData.opened}
            loading={personalData.loading}
            headline="onboarding_personal_headline"
            subtexts={['onboarding_personal_subtext']}
            subtextDone="onboarding_personal_subtext_done"
            personalNumber={personalNumber ? personalNumber : null}
            onRenderAction={() => {}}
          >
            <PersonalForm
              onSubmitForm={(formData) => onPersonalDataConfirm(formData)}
              preFilledData={onBoardingStepData}
            />
          </OnboardingCard>
        ) : null}

        {identityData.active ? (
          <OnboardingCard
            status={identityData.status}
            opened={identityData.opened}
            loading={identityData.loading}
            headline="onboarding_identity_documents_headline"
            subtexts={['onboarding_identity_documents_subtext']}
            subtextDone="onboarding_identity_documents_subtext_done"
            onRenderAction={() => {}}
          >
            <IdentityForm
              onBoardingDocumentTypes={onBoardingDocumentTypes}
              onSubmitForm={(formData) => onIdentityDataConfirm(formData)}
              preFilledData={onBoardingStepData}
              loading={identityData.loading}
            />
          </OnboardingCard>
        ) : null}

        {summaryInfo.active ? (
          <OnboardingCard
            status={summaryInfo.status}
            opened={summaryInfo.opened}
            loading={summaryInfo.loading}
            headline="onboarding_summary_info_investor_headline"
            subtexts={[
              'onboarding_summary_info_investor_subtext',
              'onboarding_summary_info_investor_subtext2',
            ]}
            subtextDone="onboarding_summary_info_investor_subtext_done"
            onRenderAction={() => {}}
          >
            <SummaryInfo
              onClick={(status) => onSummaryInfoClick(status)}
              documents={onBoardingDocuments ? onBoardingDocuments : null}
              onBoardingStepData={onBoardingStepData ? onBoardingStepData : null}
            />
          </OnboardingCard>
        ) : null}

        {confirmRegistration.active && !isRefused ? (
          <OnboardingCard
            status={confirmRegistration.status}
            opened={confirmRegistration.opened}
            loading={confirmRegistration.loading}
            showLoading={false}
            headline="onboarding_investor_confirm_registration_headline"
            subtexts={['onboarding_investor_confirm_registration_subtext']}
            subtextDone="onboarding_investor_confirm_registration_subtext_done"
            onRenderAction={
              confirmRegistration.status === 'done'
                ? () => {}
                : () => onConfirmationStep(confirmRegistration.id)
            }
            className={confirmRegistration.status === 'done' ? '' : 'confirmation-pending'}
          />
        ) : isRefused ? (
          <OnboardingCard
            isRefused={isRefused}
            status={'done'}
            opened={true}
            loading={false}
            headline="onboarding_investor_refused_registration_headline"
            subtextDone="onboarding_investor_refused_registration_subtext_done"
            onRenderAction={() => {}}
            className={isRefused ? 'refused' : ''}
          />
        ) : null}

        {amlData.active ? (
          <>
            <OnboardingCard
              status={amlData.status}
              opened={amlData.opened}
              loading={amlData.loading}
              headline="onboarding_aml_card_headline"
              subtextDone="onboarding_aml_card_subtext_done"
              onRenderAction={() => {}}
              headlineVerticalCenter={true}
            >
              <AmlForm onSubmitForm={(formData) => onAmlDataConfirm(formData)} />
            </OnboardingCard>
          </>
        ) : null}

        {finalConfirm.active && !onBoardingStepData.is_aml_rejected ? (
          <OnboardingCard
            status={isWaitingForAMLConfirmation ? 'waiting' : finalConfirm.status}
            opened={finalConfirm.opened}
            loading={finalConfirm.loading}
            waitingHeadline="onboarding_final_confirm_investor_headline_waiting"
            headlineDone="onboarding_final_confirm_investor_headline_done"
            headlineVerticalCenter={true}
            headline="onboarding_final_confirm_investor_headline"
            onRenderAction={
              finalConfirm.status === 'done' ? () => {} : () => onConfirmationStep(finalConfirm.id)
            }
            className={
              finalConfirm.status === 'done' && !isWaitingForAMLConfirmation
                ? 'completed'
                : isWaitingForAMLConfirmation
                ? 'waiting'
                : null
            }
          />
        ) : null}
        {onBoardingStepData.is_aml_rejected ? (
          <OnboardingCard
            isRefused={true}
            status={'done'}
            opened={true}
            loading={false}
            headline="onboarding_aml_rejected_headline"
            headlineVerticalCenter={true}
            subtextDone="onboarding_aml_rejected_subtext"
            onRenderAction={() => {}}
            className="refused"
          />
        ) : null}
        {finalConfirm.status === 'done' &&
        !isWaitingForAMLConfirmation &&
        !onBoardingStepData.is_aml_rejected ? (
          <>
            <OnboardingCard
              status={'pending'}
              opened={true}
              loading={false}
              headline="onboarding_deposit_investor_headline"
              subtexts={['onboarding_deposit_investor_subtext']}
              onRenderAction={() => {}}
            >
              <DepositForm />
            </OnboardingCard>
            <div className="final-button-wrap">
              {/* <div className="pulse-container"> */}
              {/* <div className="pulse"></div> */}
              <Button type="PRIMARY" onClick={() => onEntryUserAreaClick()} className="pulsing">
                <FormattedMessage
                  id="onboarding_final_btn"
                  defaultMessage={dlt['onboarding_final_btn']}
                />
              </Button>
              {/* </div> */}
            </div>
          </>
        ) : null}
      </ContentWrapSC>
    </InvestorOnboardingContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    onBoardingStep: state.onboarding.step,
    personalNumber: state.user.wm_number,
    onBoardingDocuments: state.onboarding.documents,
    onBoardingStepData: state.onboarding,
    onBoardingDocumentTypes: state.onboarding_document_types,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getInvestorOnboardingStep: ActionCreators.getInvestorOnboardingStep,
      sendInvestorOnboardingStep: ActionCreators.sendInvestorOnboardingStep,
      sendInvestorOnboardingIdentityCards: ActionCreators.sendInvestorOnboardingIdentityCards,
      sendSms: ActionCreators.sendSms,
      getInvestorDocumentTypes: ActionCreators.getInvestorDocumentTypes,
    },
    dispatch
  );
};

const InvestorOnboardingContent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(_InvestorOnboardingContent)
);

export default InvestorOnboardingContent;
